import React, { useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { ROUTES } from 'routes';
import { useApp, useUpdateDeposit } from 'providers';
import { UpdateDepositValues } from 'types';
import { UpdatePhoneValidationForm } from 'components';
import { usePageTracking } from 'hooks';
import { TRACKING_PAGES } from 'api';

export const UpdateDepositPhoneValidationPage: React.FC = () => {
  const history = useHistory();
  const location = useLocation();
  const { user } = useApp();
  const { classified, setUpdateValues } = useUpdateDeposit();

  const { nationalPhoneNumber, internationalPhoneNumber, requestId, lineType, updateValues } = (location.state ||
    {}) as {
    internationalPhoneNumber?: string;
    nationalPhoneNumber?: string;
    requestId?: string;
    lineType?: number;
    updateValues?: UpdateDepositValues;
  };

  usePageTracking(TRACKING_PAGES.MODIFICATION_VALIDATION_SMS);

  useEffect(() => {
    if (updateValues) {
      setUpdateValues(updateValues);
    }
  }, [updateValues, setUpdateValues]);

  if (
    !nationalPhoneNumber ||
    !internationalPhoneNumber ||
    !requestId ||
    lineType === undefined ||
    !updateValues ||
    user!.isPro
  ) {
    history.replace(ROUTES.update(classified!.reference));
  }

  return (
    <div>
      <UpdatePhoneValidationForm
        internationalPhoneNumber={internationalPhoneNumber!}
        nationalPhoneNumber={nationalPhoneNumber!}
        requestId={requestId!}
        lineType={lineType!}
        updateValues={updateValues!}
      />
    </div>
  );
};
